import Tool, { type ToolArgs } from '../../../tools/Tool';
import { Editor, Element, Transforms } from 'slate';
import AhaEditor from '../../../AhaEditor';
import TableUtils from '../../TablePlugin/TableUtils';
import LineHeightPicker from '../components/LineHeightPicker';

class ToolLineHeight extends Tool {
  static toolName = 'Line height';
  static iconClass = 'fa-regular fa-line-height';

  static action({ editor, lineHeight }: ToolArgs): void {
    if (!editor?.selection) return;
    if (!lineHeight) return;

    const ahaEditor = AhaEditor.getForEditor(editor);
    const tableSelection =
      ahaEditor?.controller?.state.pluginState.tableSelection;
    const tableWithinSelection = TableUtils.isTableWithinSelection(editor);

    const applyLineHeight = () => {
      if (!editor?.selection) return;

      const blockEntries = Array.from(
        Editor.nodes(editor, {
          at: editor.selection,
          mode: 'lowest',
          match: (n) => Element.isElement(n) && Editor.isBlock(editor, n),
        })
      );

      for (const blockEntry of blockEntries) {
        const path = blockEntry[1];
        Transforms.setNodes(editor, { lineHeight }, { at: path });
      }
    };

    if (tableWithinSelection && tableSelection) {
      TableUtils.applyToTable(editor, tableSelection, applyLineHeight);
    } else {
      applyLineHeight();
    }
  }

  static toolbarSubmenu() {
    return LineHeightPicker;
  }
}

export default ToolLineHeight;
